import type { MouseEvent, ReactNode } from "react";
import type { HeadsUpSidebarModel } from "@/components/heads-up/sidebar/types/heads-up-sidebar.types";

export interface HeadsUpClickHandlers {
  noteClick: (noteId: string) => (event: MouseEvent<HTMLElement>) => void;
  collectionClick: (collectionId: string) => (event: MouseEvent<HTMLElement>) => void;
}

export enum HeadsUpViewState {
  Hydrating = "HYDRATING",
  FullEmpty = "FULL_EMPTY",
  Generating = "GENERATING",
  GeneratedHasContent = "GENERATED_HAS_CONTENT",
  GeneratedNoContent = "GENERATED_NO_CONTENT",
  Error = "ERROR",
}

export interface HeadsUpContextProviderProps {
  model: HeadsUpSidebarModel;
  children: ReactNode;
}

export type { HeadsUpSidebarModel } from "@/components/heads-up/sidebar/types/heads-up-sidebar.types";
